import Typography from "../../../../componentsNew/Typography";
import IconStatus from "./IconStatus";
import GraficoStatus from "./GraficoStatus";



export default function CardDashGrafico({ titulo, className, descricao, data, tituloAtual, tituloAnterior, textoLegenda }) {

    return (
        <div className={`bg-neutras-grey-light rounded-lg p-4 mt-6 flex ${className} `}>
            <div className="w-1/3 pr-4">
                <GraficoStatus data={data} />
            </div>
            <div className="w-2/3">
                <Typography component="h3-bold" className={`w-full uppercase ${!data && "!text-text-inactive"}`}>{titulo}</Typography>
                <div className="divide-y divide-fundo-borda-grafico">
                    <Typography component="tbody2-card-grafico" className={`py-4 ${!data && "!text-text-inactive"}`}>{descricao}</Typography>
                    <div className="pt-4 divide-x divide-fundo-borda-grafico grid grid-cols-2 gap-4">
                        <div>
                            <Typography component="body1-descricao-bold" className={`py-1 ${!data && "!text-text-inactive"}`}>{tituloAtual}</Typography>
                            {data?.mesAtual != null &&
                                <IconStatus
                                    valor={data?.mesAtual}
                                    mudancaPorcentagem={data?.mudancaPorcentagem}
                                    texto={textoLegenda} />}

                        </div>
                        <div className="pl-[0.59em]">
                            <Typography component="body1-descricao-bold" className={`py-1 ${!data && "!text-text-inactive"}`}>{tituloAnterior}</Typography>
                            {data?.mesPassado != null &&
                                <IconStatus
                                    valor={data?.mesPassado}
                                    mudancaPorcentagem={data?.mudancaPorcentagem}
                                    texto={textoLegenda} />}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}
